import {Component, Input, OnInit, ViewChild} from '@angular/core';
import { TaskService, SERVICE_CONFIG } from '../../services/task.service';
import {NzModalRef, NzModalService} from 'ng-zorro-antd/modal';
import {FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { NzMessageService} from 'ng-zorro-antd/message';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import {DatePipe} from '@angular/common';
import {NzFormatBeforeDropEvent} from 'ng-zorro-antd/tree';
import {Observable, of} from 'rxjs';

// export interface TreeNodeInterface {
//   id: string;
//   name: string;
//   operationRoleCode?: string;
//   operationRoleCodes?: Array<string>;
//   operationRoleNames?: Array<string>;
//   operationOrgCode?: string;
//   operationOrgName?: string;
//   workDefName?: string;
//   relevance?: string;
//   automationDesc?: string;
//   children?: TreeNodeInterface[];
//   parent?: TreeNodeInterface;
//   expand?: boolean;
//   level?: number;
//   auditItemIdList?: Array<string>;
//   monitorItemIdList?: Array<string>;
//   isAuth?: string;
//   parentId?: string;
//   preTaskId?: string;
//   taskHandleConfig?: Object;
//   taskReportConfig?: Object;
//   taskRoutingInspectionList?: Array<string>;
//   taskStatusConfig?: Object;
// }

@Component({
  selector: 'app-task-management',
  templateUrl: './task-management.component.html',
  styleUrls: ['./task-management.component.css']
})

export class TaskManagementComponent implements OnInit {

  queryForm = new FormGroup({
    nameFuzzy: new FormControl(''),
    automationDescFuzzy: new FormControl(''),
    operationOrgCodeList: new FormControl([]),
    workDefIdList: new FormControl([]),
    operationRoleCodeFuzzy: new FormControl(''),
    relevanceList: new FormControl([]),
  });
  cdkDragEnabled = false;
  showBatchEdit = false;
  batchEditForm: FormGroup;
  showEditWidget = false;
  batchEditWidget = [];
  widgetCode;
  widgetTitle;
  submitLoading = false;
  yesOrNo = [];
  eventList = [
    {value: '1', name: '发送邮件'},
    {value: '2', name: '数据请求'}
  ];
  tplModal: any;
  addConfigModal: any;
  addTaskStatusModal: any;
  relationObject: Array<any> = []; // 关联对象
  departmentOption: Array<any> = []; // 任务部门
  workDefsOption: Array<any> = []; // 班次
  leaderOption: Array<any> = []; // 组长
  auditOptions: Array<any> = []; // 关联稽核指标
  monitorOptions: Array<any> = []; // 关联监控指标
  jobOptions: Array<any> = []; // 岗位
  preTaskOptions: Array<any> = []; // 前置任务
  childJobOptions;
  selectedTask;
  parentTask;
  operationRoleCode = [];
  taskRoutingInspectionType = 1; // 巡检时间类型  1=固定 2=区间
  interval = 5; // 间隔分钟
  boardName: string; // 面板名称
  boardId: string; // 面板ID
  addForm = this.fb.group({
    id: [],
    boardId: [],
    name: ['', [Validators.required]], // 任务名称
    groupId: ['', [Validators.required]],
    operationOrgCode: ['', [Validators.required]], // 部门
    relevance: [''], // 关联对象
    periodStartAt: [], // 区间开始日期
    periodEndAt: [],   // 区间结束日期
    operationRoleCode: [], // 岗位
    operationRoleCodes: [[]], // 岗位
    workDefId: [''], // 班次
    isAuth: [], // 是否需要授权
    createWayType: ['', [Validators.required]], // 创建方式
    preTaskId: [[]], // 前置任务
    automation: ['', [Validators.required]], // 频率设置
    automationDesc: [''], // 频率设置描述
    // auditItemIdList: [], // 关联稽核
    // monitorItemIdList: [], // 关联监控
    taskRoutingInspectionList: [], // 关联巡检配置
    description: []
  });
  addChildForm = this.fb.group({
    id: [],
    boardId: [],
    parentId: [],
    name: ['', [Validators.required]], // 任务名称
    groupId: [''],
    operationOrgCode: ['', [Validators.required]], // 部门
    relevance: [''], // 关联对象
    periodStartAt: [], // 区间开始日期
    periodEndAt: [],   // 区间结束日期
    operationRoleCode: [], // 岗位
    operationRoleCodes: [[]], // 岗位
    workDefId: [''], // 班次
    isAuth: [], // 是否需要授权
    createWayType: ['', [Validators.required]], // 创建方式
    preTaskId: [[]], // 前置任务
    automation: ['', [Validators.required]], // 频率设置
    automationDesc: [''], // 频率设置描述
    // auditItemIdList: [], // 关联稽核
    // monitorItemIdList: [], // 关联监控
    taskRoutingInspectionList: [], // 关联巡检配置
    description: [] // 任务描述
  });

  schedulerConditionData: any; // 存放定时数据
  childSchedulerConditionData: any;
  operateType = 'add';
  sortTreeData = [];
  listOfMapData = [];
  listOfCurrentPageData = [];
  mapOfExpandedData = {};
  pageTotal = 0;
  pageIndex = 1;
  pageSize = 200;
  pageSizeOptions = [50, 100, 200, 500];
  // 任务处理配置对应参数
  taskConfigData = [];
  taskConfigForm = this.fb.group({
    taskDefId: [],
    title: ['', [Validators.required]], // 标题
    operationCode: [''], // 操作
    operationName: [],
    optionConfig: [],
    status: []
  });
  typeList = [];
  reportList = [];
  reportParamList = [];
  optionData = [];

  // 关联报表配置
  reportConfigData = [];
  reportConfigForm = this.fb.group({
    reportId: ['', [Validators.required]],
    // reportParam: [], // 设置报表入参
  });

  queryParam: any = {};
  page = {
    page: this.pageIndex,
    rows: this.pageSize
  };
  isChildTask = false; // 是否新增子任务
  // 任务状态设置
  isAddStatusListVisible = false;
  statusOptionData = [];
  statusItemList = [];
  isAddStatusItemVisible = false;
  addItemForm: FormGroup = this.fb.group({
    index: [null, [Validators.required]],
    label: [null, [Validators.required]],
    color: [null, [Validators.required]],
    event: [null],
    url: [null],
    symbol: [null]
  });
  initColor = [
    'rgb(253, 171, 61)',
    'rgb(0, 200, 117)',
    'rgb(226, 68, 92)',
    'rgb(87, 155, 252)',
    'rgb(159 165 165)',
    'rgb(255, 100, 46)',
    'rgb(0, 134, 192)',
    'rgb(162, 93, 220)',
    'rgb(127, 83, 71)',
    'rgb(255, 90, 196)',
    'rgb(255, 21, 138)',
    'rgb(187, 51, 84)',
    'rgb(3, 127, 76)',
    'rgb(255, 203, 0)',
    'rgb(202, 182, 65)',
    'rgb(156, 211, 38)'
  ];
  currentPanelColor = 'rgba(255,255,255, 1)';
  isEditStatusItem = false;
  currentStatusItem: any;
  currentStatusList: any;
  taskStatusList = [];
  // 关联巡检
  inspectionList = [];
  inspectionListObj = [];
  inspectionDate = null;
  inspectionStartDate = null;
  inspectionEndDate = null;
  isInspectionVisible = false;
  isSubmitLoading = false;
  isLoading = false;
  boardGroupData = [];
  // 表格选择
  checked = false;
  indeterminate = false;
  setOfCheckedId = new Set<number>();
  // 任务系统参数
  taskSystemParameter: any;
  // 关联稽核监控
  isAddAuditVisible = false;
  isAddMonitorVisible = false;
  auditBoardList = null;
  auditBoardItem = [];
  isAddIndicatorVisible = false;
  indicatorBoardList = null;
  indicatorBoardItem = [];
  auditBoardListOption = [];
  indicatorBoardListOption = [];
  auditBoardItemOption = [];
  indicatorBoardItemOption = [];
  formType: string;
  addAuditTags = [];
  addMonitorTags = [];
  addAuditTagsCache = [];
  addMonitorTagsCache = [];
  @Input('group') set groupChange(group) {
    if (group) {
      this.boardGroupData = group;
      this.boardId = this.boardGroupData[0].boardId;
    }
  }
  @Input('taskSystemParameter') set ChangeParam(data: any) {
    if (data) {
      this.taskSystemParameter = data;
    }
  }
  @ViewChild('modelOrganizationNew', { static: true }) modelOrganizationNew: any;
  @ViewChild('modelOrganizationNewFooter', { static: true }) modelOrganizationNewFooter: any;
  @ViewChild('viewTask') viewTask: any;
  @ViewChild('viewTaskFooter') viewTaskFooter: any;
  @ViewChild('setScheduler') setScheduler: any;
  @ViewChild('setChildScheduler') setChildScheduler: any;
  @ViewChild('taskConfigModal') taskConfigModal: any;
  @ViewChild('taskConfigFooterModal') taskConfigFooterModal: any;
  @ViewChild('reportConfigModal') reportConfigModal: any;
  @ViewChild('reportConfigFooterModal') reportConfigFooterModal: any;
  @ViewChild('addChildTaskModal') addChildTaskModal: any;
  @ViewChild('addChildTaskModalFooter') addChildTaskModalFooter: any;
  @ViewChild('viewChildTask') viewChildTask: any;
  @ViewChild('viewChildTaskFooter') viewChildTaskFooter: any;
  constructor(
    private modalService: NzModalService,
    private fb: FormBuilder,
    private sys: TaskService,
    private message: NzMessageService,
    private datePipe: DatePipe
  ) { }

  ngOnInit(): void {
    this.batchEditForm = this.fb.group({
      ids: [],
      groupId: [],
      boardId: [],
      operationOrgCode: [''], // 部门
      operationRoleCode: [], // 岗位
      operationRoleCodes: [[] ], // 岗位
      workDefId: ['' ], // 班次
      isAuth: [], // 是否需要授权
      createWayType: [''], // 创建方式
      preTaskId: [[]], // 前置任务
      automation: ['' ], // 频率设置
      automationDesc: [''], // 频率设置描述
      description: [],
    });
    this.relationObject = this.getDictionaryOption('operation_relevance_object');
    this.yesOrNo = this.getDictionaryOption('yes_or_no');
    this.getData({page: 1, rows: 200});
    this.getDepartment();
    if (this.taskSystemParameter && this.taskSystemParameter.audit && this.taskSystemParameter.audit === 'audit') {
      this.addForm.addControl('auditItemIdList', this.fb.control([]));
      this.addChildForm.addControl('auditItemIdList', this.fb.control([]));
      this.getAudit();
    }
    if (this.taskSystemParameter && this.taskSystemParameter.indicator && this.taskSystemParameter.indicator === 'indicator') {
      this.addForm.addControl('monitorItemIdList', this.fb.control([]));
      this.addChildForm.addControl('monitorItemIdList', this.fb.control([]));
      this.getIndicatorList();
    }
  }

  getData(param) {
    const params = param;
    params['boardId'] = this.boardGroupData[0].boardId;
    this.isLoading = true;
    this.sys.getTaskList(param).subscribe(res => {
      this.isLoading = false;
      if (res) {
        this.pageTotal = res['page']['totalElements'];
        this.pageSize = res['page']['size'];
        this.pageIndex = res['page']['number'];
        this.listOfMapData = res['_embedded'] && res['_embedded']['vos'] || [];
        this.listOfMapData.forEach(item => {
          this.mapOfExpandedData[item.id] = this.convertTreeToList(item);
          item['title'] = item.name;
          item['key'] = item.id;
          this.transferChildren(item);
        });
        this.sortTreeData = [
          {
            title: '任务管理',
            key: '00000001',
            children: this.listOfMapData
          }
        ];
        // 处理前置任务选项
        for (const i in this.mapOfExpandedData) {
          if (this.mapOfExpandedData.hasOwnProperty(i)) {
            this.mapOfExpandedData[i].forEach((item) => {
              this.preTaskOptions = [item, ...this.preTaskOptions];
            });
          }
        }
        const obj = {};
        this.preTaskOptions = this.preTaskOptions.reduce((cur, next) => {
          obj[next.id] ? '' : obj[next.id] = true && cur.push(next);
          return cur;
        }, []);
      }
    }, () => {
      this.isLoading = false;
    });
  }
  transferChildren(item: any) {
    const children = item.children;
    if (children && children.length > 0 ) {

      children.forEach(child => {
        child['title'] = child.name;
        child['key'] = child.id;
        this.transferChildren(child);
      });
    } else {
      item['isLeaf'] = true;
      item['children'] = [];
    }
}

  getDepartment() {
    this.sys.getTaskDepartments().subscribe( res => {
      this.departmentOption = res && res['_embedded'] && res['_embedded'].vos ? res['_embedded'].vos : [];
    });
  }

  // 查询条件-搜索
  queryChange(event) {
    this.queryParam = event;
    this.queryParam['page'] = 1;
    this.queryParam['rows'] = 200;
    this.getData(this.queryParam);
  }

  // 分页-页码变更
  pageIndexChange(event) {
    this.page.page = event;
    this.getData(this.page);
  }

  // 分页-分页条数变更
  pageSizeChange(event) {
    this.page.rows = event;
    this.getData(this.page);
  }

  // 操作
  // operateChange(event) {
  //   if (event.event === 'customAdd') {
  //     this.oprateType = 'add';
  //     this.addHandle();
  //   }
  //   if (event.event === 'customEdit') {
  //     this.oprateType = 'edit';
  //     this.currentData = event.rowData
  //     this.editHandle();
  //   }
  // }

  // 添加任务
  addTask() {
    this.operateType = 'add';
    this.formType = 'parent';
    this.isSubmitLoading = false;
    this.isChildTask = false;
    this.addHandle();
  }

  addHandle() {
    this.addForm.reset();
    this.taskStatusList = [];
    this.taskConfigData = [];
    this.reportConfigData = [];
    this.inspectionList = [];
    this.inspectionListObj = [];
    this.addMonitorTags = [];
    this.addAuditTags = [];
    this.addForm.enable();
    this.schedulerConditionData = {};
    this.tplModal = this.modalService.create({
      nzContent: this.modelOrganizationNew,
      nzFooter: this.modelOrganizationNewFooter,
      nzMaskClosable: false,
      nzTitle: '新增任务',
      nzWidth: '60%',
      nzWrapClassName: 'vertical-center-modal',
      nzOnCancel: () => {
        this.addCancel(true);
        return false;
      }
    });
  }

  addCancel(isTip?) {
    if (isTip) {
      this.modalService.confirm({
        nzTitle: '关闭提示',
        nzContent: '弹框关闭之后填写数据将丢失，请确认是否关闭？',
        nzWrapClassName: 'vertical-center-modal',
        nzOnOk: () => {
          this.tplModal.destroy();
        }
      });
    } else {
      this.tplModal.destroy();
    }
  }

  viewHandle(item) {
    this.operateType = 'view';
    this.getWorks({operationOrgCode: item.operationOrgCode});
    this.getJob({orgCode: item.operationOrgCode});
    this.sys.getTaskDetail(item.id).subscribe(res => {
      if (res) {
        if (res['preTaskId']) {
          res['preTaskId'] = res['preTaskId'].split(',');
        } else {
          res['preTaskId'] = [];
        }
        if (!res['parentId']) {
          this.viewTaskDetail(res);
        } else {
          this.viewChildTaskDetail(res);
        }
      } else {
        this.message.error('获取任务详情异常，请稍后重试');
      }
    });
  }

  viewTaskDetail(res) {
    this.selectedTask = res;
    this.addForm.patchValue(res);
    this.addForm.get('groupId').setValue(this.selectedTask.groupId);
    this.addForm.disable();
    // this.taskStatusList = res['taskStatusConfig'] || [];
    this.taskConfigData = res['taskHandleConfig'] || [];
    if (this.taskSystemParameter && this.taskSystemParameter.report && this.taskSystemParameter.report === 'report') {
      this.reportConfigData = res['taskReportConfig'] || [];
    }
    this.inspectionList = res['taskRoutingInspectionList'] || [];
    this.inspectionListObj = res['taskRoutingInspectionList'] || [];
    this.inspectionListObj.forEach(_item => {
      if (_item) {
        _item = JSON.parse(_item);
      }
    });
    this.tplModal = this.modalService.create({
      nzContent: this.viewTask,
      nzFooter: this.viewTaskFooter,
      nzMaskClosable: false,
      nzTitle: '任务详情',
      nzWidth: '60%',
      nzWrapClassName: 'vertical-center-modal',
      nzOnCancel: () => {
        this.addCancel();
        return false;
      }
    });
  }

  viewChildTaskDetail(res) {
    this.selectedTask = res;
    this.addChildForm.patchValue(res);
    this.addChildForm.get('groupId').setValue(this.selectedTask.groupId);
    this.addChildForm.disable();
    // this.taskStatusList = res['taskStatusConfig'] || [];
    this.taskConfigData = res['taskHandleConfig'] || [];
    if (this.taskSystemParameter && this.taskSystemParameter.report && this.taskSystemParameter.report === 'report') {
      this.reportConfigData = res['taskReportConfig'] || [];
    }
    this.inspectionList = res['taskRoutingInspectionList'] || [];
    this.inspectionListObj = res['taskRoutingInspectionList'] || [];
    this.inspectionListObj.forEach(_item => {
      if (_item) {
        _item = JSON.parse(_item);
      }
    });
    this.tplModal = this.modalService.create({
      nzContent: this.viewChildTask,
      nzFooter: this.viewChildTaskFooter,
      nzMaskClosable: false,
      nzTitle: '任务详情',
      nzWidth: '60%',
      nzWrapClassName: 'vertical-center-modal',
      nzOnCancel: () => {
        this.addCancel();
        return false;
      }
    });
  }

  // 修改功能
  editHandle(item) {
    this.operateType = 'edit';
    if (item.parent) {
      this.parentTask = item.parent;
    }
    this.getWorks({operationOrgCode: item.operationOrgCode});
    this.getJob({orgCode: item.operationOrgCode});
    this.sys.getTaskDetail(item.id).subscribe(res => {
      if (res) {
        this.selectedTask = res;
        if (res['preTaskId']) {
          res['preTaskId'] = res['preTaskId'].split(',');
        } else {
          res['preTaskId'] = [];
        }
        if (!res['parentId']) {
          this.editTask(res);
          this.formType = 'parent';
        } else {
          this.formType = 'child';
          this.editChildTask(res);
        }
      } else {
        this.message.error('获取任务详情异常，请稍后重试');
      }
    });
  }

  // 编辑任务
  editTask(res) {
    this.schedulerConditionData = JSON.parse(res['automation']);
    if (res.auditItemIdList && res.auditItemIdList.length) {
      this.addAuditTags = [];
      res.auditItemIdList.forEach(i => {
        this.auditOptions.forEach(j => {
          if (i === j.id) {
            const obj = {
              id: j.id,
              name: j.name
            };
            this.addAuditTags.push(obj);
          }
        });
      });
      const obj = {};
      this.addAuditTags = this.addAuditTags.reduce((cur, next) => {
        obj[next.id] ? '' : obj[next.id] = true && cur.push(next);
        return cur;
      }, []);
    } else {
      this.addAuditTags = [];
    }
    if (res.monitorItemIdList && res.monitorItemIdList.length) {
      this.addMonitorTags = [];
      res.monitorItemIdList.forEach(i => {
        this.monitorOptions.forEach(j => {
          if (i === j.id) {
            const obj = {
              id: j.id,
              name: j.name
            };
            this.addMonitorTags.push(obj);
          }
        });
      });
      const _obj = {};
      this.addMonitorTags = this.addMonitorTags.reduce((cur, next) => {
        _obj[next.id] ? '' : _obj[next.id] = true && cur.push(next);
        return cur;
      }, []);
    } else {
      this.addMonitorTags = [];
    }
    this.addForm.patchValue(res);
    this.addForm.enable();
    // this.taskStatusList = res['taskStatusConfig'] || [];
    this.taskConfigData = res['taskHandleConfig'] || [];
    if (this.taskSystemParameter && this.taskSystemParameter.report && this.taskSystemParameter.report === 'report') {
      this.reportConfigData = res['taskReportConfig'] || [];
    }
    this.inspectionList = res['taskRoutingInspectionList'] || [];
    this.inspectionListObj = res['taskRoutingInspectionList'] || [];
    this.inspectionListObj.forEach((_item, i) => {
      if (_item) {
        const newArr = JSON.parse(_item);
        this.inspectionListObj[i] = newArr;
      }
    });
    this.tplModal = this.modalService.create({
      nzContent: this.modelOrganizationNew,
      nzFooter: this.modelOrganizationNewFooter,
      nzMaskClosable: false,
      nzTitle: '编辑任务',
      nzWidth: '60%',
      nzWrapClassName: 'vertical-center-modal',
      nzOnCancel: () => {
        this.addCancel();
        return false;
      }
    });
  }

  // 编辑子任务
  editChildTask(res) {
    if (this.parentTask) {
      this.sys.getProductJob({orgCode: this.parentTask.operationOrgCode}).subscribe(res => {
        this.jobOptions = res && res['_embedded'] && res['_embedded'].vos ? res['_embedded'].vos : [];
        this.childJobOptions = JSON.parse(JSON.stringify(this.jobOptions));
        for (const option of this.childJobOptions) {
          // 如果岗位不在父任务的岗位中，则禁用
          option.disable = !(this.parentTask.operationRoleCodes && this.parentTask.operationRoleCodes.includes(option.roleId));
        }
      });
    }
    this.childSchedulerConditionData = JSON.parse(res['automation']);
    if (res.auditItemIdList && res.auditItemIdList.length) {
      this.addAuditTags = [];
      res.auditItemIdList.forEach(i => {
        this.auditOptions.forEach(j => {
          if (i === j.id) {
            const obj = {
              id: j.id,
              name: j.name
            };
            this.addAuditTags.push(obj);
          }
        });
      });
    }
    if (res.monitorItemIdList && res.monitorItemIdList.length) {
      this.addMonitorTags = [];
      res.monitorItemIdList.forEach(i => {
        this.monitorOptions.forEach(j => {
          if (i === j.id) {
            const obj = {
              id: j.id,
              name: j.name
            };
            this.addMonitorTags.push(obj);
          }
        });
      });
    }
    const obj = {};
    this.addAuditTags = this.addAuditTags.reduce((cur, next) => {
      obj[next.id] ? '' : obj[next.id] = true && cur.push(next);
      return cur;
    }, []);
    const _obj = {};
    this.addMonitorTags = this.addMonitorTags.reduce((cur, next) => {
      _obj[next.id] ? '' : _obj[next.id] = true && cur.push(next);
      return cur;
    }, []);
    this.addChildForm.patchValue(res);
    this.addChildForm.enable();
    // this.taskStatusList = res['taskStatusConfig'] || [];
    this.taskConfigData = res['taskHandleConfig'] || [];
    if (this.taskSystemParameter && this.taskSystemParameter.report && this.taskSystemParameter.report === 'report') {
      this.reportConfigData = res['taskReportConfig'] || [];
    }
    this.inspectionList = res['taskRoutingInspectionList'] || [];
    this.inspectionListObj = res['taskRoutingInspectionList'] || [];
    this.inspectionListObj.forEach((_item, i) => {
      if (_item) {
        const newArr = JSON.parse(_item);
        this.inspectionListObj[i] = newArr;
      }
    });
    this.tplModal = this.modalService.create({
      nzContent: this.addChildTaskModal,
      nzFooter: this.addChildTaskModalFooter,
      nzMaskClosable: false,
      nzTitle: '编辑任务',
      nzWidth: '60%',
      nzWrapClassName: 'vertical-center-modal',
      nzOnCancel: () => {
        this.addCancel();
        return false;
      }
    });
  }

  deleteTask(item) {
    this.modalService.confirm({
      nzTitle: '删除提示',
      nzContent: '是否确认删除该条任务？',
      nzWrapClassName: 'vertical-center-modal',
      nzOnOk: () => {
        this.sys.deleteTask(item.id).subscribe(res => {
          this.message.success('删除成功');
          this.getData(this.page);
        });
      }
    });
  }

  // 部门联动
  changeDepartment(event) {
    if (event) {
      this.getWorks({operationOrgCode: event});
      this.getJob({orgCode: event});
    } else {
      this.workDefsOption = [];
      this.jobOptions = [];
    }
    // this.addForm.get('operationRoleCode').patchValue('');
    this.addForm.get('operationRoleCodes').patchValue([]);
    this.addForm.get('workDefId').patchValue('');
    this.addChildForm.get('operationRoleCodes').patchValue([]);
    this.addChildForm.get('workDefId').patchValue('');
  }
  changeOperationRole(event) {
    // if (event) {
    //   this.getLeader({roleId: event});
    // } else {
    //   this.leaderOption = [];
    // }
  }

  // 管理对象
  changeRelevance(event) {
    // 不是产品选项择清空岗位
    // this.addForm.get('operationRoleCode').patchValue('');
  }

  changeDepartmentForSearch(event) {
    if (event) {
      this.getWorks({operationOrgCodeList: event});
      this.getJob({orgCodeList: event});
    } else {
      this.workDefsOption = [];
      this.jobOptions = [];
    }
    this.queryForm.get('operationRoleCodeFuzzy').patchValue('');
    this.queryForm.get('workDefIdList').patchValue([]);

  }

  // 班次
  getWorks(params) {
    this.sys.getWorkDefs(params).subscribe( res => {
      this.workDefsOption = res && res['_embedded'] && res['_embedded'].vos ? res['_embedded'].vos : [];
    });
  }

  // 关联稽核指标
  getAudit() {
    this.sys.getAuditLists().subscribe( res => {
      this.auditOptions = res && res['_embedded'] && res['_embedded'].vos ? res['_embedded'].vos : [];
    });
  }
  // 关联监控指标
  getIndicatorList() {
    this.sys.getIndicatorList().subscribe( res => {
      this.monitorOptions = res && res['_embedded'] && res['_embedded'].vos ? res['_embedded'].vos : [];
    });
  }
  // 岗位
  getJob(params) {
    this.sys.getProductJob(params).subscribe( res => {
      this.jobOptions = res && res['_embedded'] && res['_embedded'].vos ? res['_embedded'].vos : [];
    });
  }
  // 组长
  getLeader(params) {
    this.sys.getOrgMember(params).subscribe( res => {
      this.leaderOption = res && res['_embedded'] && res['_embedded'].vos ? res['_embedded'].vos : [];
    });
  }

  getSchedulerData(event) {
    this.addForm.get('automation').patchValue(JSON.stringify(event.config));
    this.addForm.get('automationDesc').patchValue(event.text);
  }

  submitForm() {
    this.setScheduler.schedulerOnSubmit();
    this.addForm.get('boardId').patchValue(this.boardId);
    const schedulerData = JSON.parse(this.addForm.get('automation').value);
    let  schedulerValid = true;
    if (schedulerData.type === 'weekly' || schedulerData.type === 'monthly' || schedulerData.type === 'months') {
      if (!schedulerData.days || !schedulerData.days.length) {
        schedulerValid = false;
      }
    }
    for (const i in this.addForm.controls) {
      this.addForm.controls[i].markAsDirty();
      this.addForm.controls[i].updateValueAndValidity();
    }
    const formValue = this.addForm.value;
    formValue['taskHandleConfig'] = this.taskConfigData;
    if (this.taskSystemParameter && this.taskSystemParameter.report && this.taskSystemParameter.report === 'report') {
      formValue['taskReportConfig'] = this.reportConfigData;
    }
    formValue['taskRoutingInspectionList'] = this.inspectionList;
    if (formValue['preTaskId'] && formValue['preTaskId'].length) {
      formValue['preTaskId'] = formValue['preTaskId'].join(',');
    } else {
      formValue['preTaskId'] = '';
    }
    if (formValue['periodEndAt']) {
      formValue['periodEndAt'] = formValue['periodEndAt'].valueOf();
    }
    if (formValue['periodStartAt']) {
      formValue['periodStartAt'] = formValue['periodStartAt'].valueOf();
    }
    if (this.addForm.valid && schedulerValid) {
      this.isSubmitLoading = true;
      if (this.operateType === 'add') {
        this.sys.addTask(formValue).subscribe( res => {
          this.message.success('新增成功！');
          this.isSubmitLoading = false;
          this.addCancel();
          this.getData(this.page);
        }, () => {
          this.isSubmitLoading = false;
        });
      } else {
        if (formValue.taskRoutingInspectionList) {
          formValue.taskRoutingInspectionList.forEach((item, i) => {
            if (!(typeof item === 'string')) {
              formValue.taskRoutingInspectionList[i] = JSON.stringify(item);
            }
          });
        }
        this.sys.editTask(formValue).subscribe( res => {
          this.message.success('修改成功！');
          this.isSubmitLoading = false;
          this.addCancel();
          this.getData(this.page);
        }, () => {
          this.isSubmitLoading = false;
        });
      }
    }
  }

  // 获取字典并转成下拉选项
  getDictionaryOption(name: string, key?: string) {
    const lsK = key ? key : 'init';
    const ls = JSON.parse(localStorage.getItem(lsK));
    const options = [];
    if (ls) {
      for (const item in ls.dictionaries[name]) {
        if (ls.dictionaries[name].hasOwnProperty(item)) {
          const obj = {
            label: ls.dictionaries[name][item],
            value: item
          };
          options.push(obj);
        }
      }
      return options;
    }
  }

  collapse(array, data, $event: boolean): void {
    if (!$event) {
      if (data.children) {
        data.children.forEach(d => {
          const target = array.find(a => a.id === d.id)!;
          target.expand = false;
          this.collapse(array, target, false);
        });
      } else {
        return;
      }
    }
  }

  convertTreeToList(root) {
    const stack = [];
    const array = [];
    const hashMap = {};
    stack.push({ ...root, level: 0, expand: true });

    while (stack.length !== 0) {
      const node = stack.pop()!;
      this.visitNode(node, hashMap, array);
      if (node.children) {
        for (let i = node.children.length - 1; i >= 0; i--) {
          stack.push({ ...node.children[i], title: node.name, key: node.id, level: node.level! + 1, expand: true, parent: node });
        }
      }
    }

    return array;
  }

  visitNode(node, hashMap: { [key: string]: boolean }, array): void {
    if (!hashMap[node.id]) {
      hashMap[node.id] = true;
      array.push(node);
    }
  }
  // 点击任务状态配置
  addTaskStatusConfig() {
    this.isAddStatusListVisible = true;
  }
  // 点击任务处理配置
  addTaskConfig() {
    this.taskConfigForm.reset();
    this.taskConfigForm.get('status').setValue(true);
    this.optionData = [];
    this.addConfigModal = this.modalService.create({
      nzContent: this.taskConfigModal,
      nzFooter: this.taskConfigFooterModal,
      nzMaskClosable: false,
      nzTitle: '任务处理配置',
      nzWidth: '60%',
      nzWrapClassName: 'vertical-center-modal',
      nzOnCancel: () => {
        this.addConfigCancel(true);
        return false;
      }
    });
  }

  editTaskOption(item) {
    this.taskConfigForm.patchValue(item);
    this.optionData = item.optionConfig;
    this.addConfigModal = this.modalService.create({
      nzContent: this.taskConfigModal,
      nzFooter: this.taskConfigFooterModal,
      nzMaskClosable: false,
      nzTitle: '任务处理配置',
      nzWidth: '60%',
      nzWrapClassName: 'vertical-center-modal',
      nzOnCancel: () => {
        this.addConfigCancel(true);
        return false;
      }
    });
  }

  deleteTaskOption(i) {
    this.taskConfigData.splice(i, 1);
  }

  addConfigConfirm() {
    this.taskConfigData = [];
    this.taskConfigForm.get('optionConfig').setValue(this.optionData);
    this.taskConfigData.push(this.taskConfigForm.value);
    // this.taskConfigData = [this.taskConfigForm.value, ...this.taskConfigForm.value];
    this.addConfigModal.destroy();
  }
  addTaskStatusConfirm() {
    this.addTaskStatusModal.destroy();
  }

  addReportConfigConfirm() {
    for (const i in this.reportConfigForm.controls) {
      this.reportConfigForm.controls[i].markAsDirty();
      this.reportConfigForm.controls[i].updateValueAndValidity();
    }
    if (!this.reportConfigForm.invalid) {
      this.reportList.forEach(item => {
        if (item.id === this.reportConfigForm.value.reportId) {
          const obj = {
            reportId: item.id,
            name: item.name
          };
          this.reportConfigData.push(obj);
        }
      });
      this.addConfigModal.destroy();
    }
  }

  addConfigCancel(isTip?) {
    if (isTip) {
      this.modalService.confirm({
        nzTitle: '关闭提示',
        nzContent: '弹框关闭之后填写数据将丢失，请确认是否关闭？',
        nzWrapClassName: 'vertical-center-modal',
        nzOnOk: () => {
          this.addConfigModal.destroy();
        }
      });
    } else {
      this.addConfigModal.destroy();
    }
  }
  addTaskStatusCancel(isTip?) {
    if (isTip) {
      this.modalService.confirm({
        nzTitle: '关闭提示',
        nzContent: '弹框关闭之后填写数据将丢失，请确认是否关闭？',
        nzWrapClassName: 'vertical-center-modal',
        nzOnOk: () => {
          this.addTaskStatusModal.destroy();
        }
      });
    } else {
      this.addTaskStatusModal.destroy();
    }
  }

  operationCodeChange() {
    // if (this.taskConfigForm.get('operationCode').value) {
    //   for (const item of this.yesOrNo) {
    //     if (item.value == this.taskConfigForm.get('operationCode').value) {
    //       this.taskConfigForm.get('operationName').setValue(item.label);
    //       break;
    //     }
    //   }
    // }
  }
  // 添加
  addOption() {
    const obj = {
      label: '',
      value: '',
      event: ''
    };
    this.optionData.push(obj);
  }

  deleteOption(i) {
    this.optionData.splice(i, 1);
  }

  // 点击任务处理配置
  addReportConfig() {
    this.getReportData();
    this.reportConfigForm.reset();
    this.addConfigModal = this.modalService.create({
      nzContent: this.reportConfigModal,
      nzFooter: this.reportConfigFooterModal,
      nzMaskClosable: false,
      nzTitle: '关联报表配置',
      nzWidth: '600px',
      nzWrapClassName: 'vertical-center-modal',
      nzOnCancel: () => {
        this.addConfigCancel(true);
        return false;
      }
    });
  }

  deleteReportConfig(i) {
    this.reportConfigData.splice(i, 1);
  }

  editReportConfig(item) {
    this.reportConfigForm.patchValue(item);
    this.addConfigModal = this.modalService.create({
      nzContent: this.reportConfigModal,
      nzFooter: this.reportConfigFooterModal,
      nzMaskClosable: false,
      nzTitle: '关联报表配置',
      nzWidth: '600px',
      nzWrapClassName: 'vertical-center-modal',
      nzOnCancel: () => {
        this.addConfigCancel(true);
        return false;
      }
    });
  }

  // 添加子任务
  addChildTaskOperate(item) {
    this.formType = 'child';
    this.sys.getTaskDetail(item.id).subscribe(res => {
      this.selectedTask = res;
      this.addChildForm.get('groupId').setValue(this.selectedTask.groupId);
      // this.taskStatusList = this.selectedTask.taskStatusConfig ? this.selectedTask.taskStatusConfig : [];
      this.taskConfigData = this.selectedTask.taskHandleConfig ? this.selectedTask.taskHandleConfig : [];
    }, () => {
      this.selectedTask = item;
    });
    this.selectedTask = item;
    if (this.selectedTask.operationOrgCode) {
      this.getWorks({operationOrgCode: this.selectedTask.operationOrgCode});
      this.getJob({orgCode: this.selectedTask.operationOrgCode});
    } else {
      this.workDefsOption = [];
      this.jobOptions = [];
    }
    this.sys.getProductJob({orgCode: item.operationOrgCode}).subscribe(res => {
      this.jobOptions = res && res['_embedded'] && res['_embedded'].vos ? res['_embedded'].vos : [];
      this.childJobOptions = JSON.parse(JSON.stringify(this.jobOptions));
      for (let option of this.childJobOptions) {
        // 如果岗位不在父任务的岗位中，则禁用
        option.disable = !(item.operationRoleCodes && item.operationRoleCodes.includes(option.roleId));
      }
      this.childJobOptions = this.childJobOptions.filter(d => d.disable !== true);
    });
    this.operateType = 'add';
    this.addChildForm.reset();
    this.reportConfigData = [];
    this.inspectionList = [];
    this.inspectionListObj = [];
    this.addChildForm.get('parentId').setValue(item.id);
    this.addChildForm.get('operationOrgCode').setValue(item.operationOrgCode);
    this.addChildForm.get('relevance').setValue(item.relevance);
    this.addChildForm.get('workDefId').setValue(item.workDefId);
    this.addChildForm.get('createWayType').setValue(item.createWayType);
    this.addMonitorTags = [];
    this.addAuditTags = [];
    this.childSchedulerConditionData = {};
    this.isChildTask = true;
    this.tplModal = this.modalService.create({
      nzContent: this.addChildTaskModal,
      nzFooter: this.addChildTaskModalFooter,
      nzMaskClosable: false,
      nzTitle: '新增子任务',
      nzWidth: '60%',
      nzWrapClassName: 'vertical-center-modal',
      nzOnCancel: () => {
        this.addCancel(true);
        return false;
      }
    });
  }

  addChildTaskConfirm() {
    this.setChildScheduler.schedulerOnSubmit();
    this.addChildForm.get('boardId').patchValue(this.boardId);
    const schedulerData = JSON.parse(this.addChildForm.get('automation').value);
    let  schedulerValid = true;
    if (schedulerData.type === 'weekly' || schedulerData.type === 'monthly') {
      if (!schedulerData.days || !schedulerData.days.length) {
        schedulerValid = false;
      }
    }

    for (const i in this.addChildForm.controls) {
      this.addChildForm.controls[i].markAsDirty();
      this.addChildForm.controls[i].updateValueAndValidity();
    }
    const formValue = this.addChildForm.value;
    // formValue['taskStatusConfig'] = this.taskStatusList;
    formValue['taskHandleConfig'] = this.taskConfigData;
    if (this.taskSystemParameter && this.taskSystemParameter.report && this.taskSystemParameter.report === 'report') {
      formValue['taskReportConfig'] = this.reportConfigData;
    }
    formValue['taskRoutingInspectionList'] = this.inspectionList;
    if (formValue['preTaskId'] && formValue['preTaskId'].length) {
      formValue['preTaskId'] = formValue['preTaskId'].join(',');
    } else {
      formValue['preTaskId'] = '';
    }
    if (formValue['periodEndAt']) {
      formValue['periodEndAt'] = formValue['periodEndAt'].valueOf();
    }
    if (formValue['periodStartAt']) {
      formValue['periodStartAt'] = formValue['periodStartAt'].valueOf();
    }
    if (this.addChildForm.valid && schedulerValid) {
      this.isSubmitLoading = true;
      if (this.operateType === 'add') {
        this.sys.addTask(formValue).subscribe( res => {
          this.message.success('新增成功！');
          this.isSubmitLoading = false;
          this.addCancel();
          this.getData(this.page);
        }, () => {
          this.isSubmitLoading = false;
        });
      } else {
        if (formValue.taskRoutingInspectionList) {
          formValue.taskRoutingInspectionList.forEach((item, i) => {
            if (!(typeof item === 'string')) {
              formValue.taskRoutingInspectionList[i] = JSON.stringify(item);
            }
          });
        }
        this.sys.editTask(formValue).subscribe( res => {
          this.message.success('修改成功！');
          this.isSubmitLoading = false;
          this.addCancel();
          this.getData(this.page);
        }, () => {
          this.isSubmitLoading = false;
        });
      }
    }
  }

  addChildTaskCancel() {
    this.addCancel(true);
  }

  getChildSchedulerData(event) {
    this.addChildForm.get('automation').patchValue(JSON.stringify(event.config));
    this.addChildForm.get('automationDesc').patchValue(event.text);
  }
  // 任务状态设置新增操作
  openAddStatusList() {
    this.isAddStatusListVisible = true;
    this.isEditStatusItem = false;
    this.currentStatusList = {};
  }
  editStatusList(data, i) {
    this.isAddStatusListVisible = true;
    this.statusOptionData = data.optionConfig;
    this.currentStatusList = data;
    this.isEditStatusItem = true;
  }
  removeStatusList(i) {
    this.taskStatusList.splice(i, 1);
    // 更新表单值
    this.addForm.get('taskStatusConfig').patchValue(this.taskStatusList);
  }

  beforeDrop(arg: NzFormatBeforeDropEvent): Observable<boolean> {
    // if insert node into another node, wait 1s
    console.log(arg);
    // 拖动位置
    const pos = arg.pos;
    const dragNode = arg.dragNode; // 拖动的节点
    const tarNode = arg.node; // 目标节点
    const dragNodeParentId = dragNode.origin.parentId;
    const tarNodeParentId = tarNode.origin.parentId;
    console.log(dragNodeParentId, tarNodeParentId);
    if (pos === 0) {
      return of(false);
    }
    if (dragNodeParentId !== tarNodeParentId) {
      return of(false);
    }
    return of(true);
  }
  sortOnOk(): void {
    this.sys.drag(this.sortTreeData[0].children).subscribe( res => {
      if (res === true) {
        this.cdkDragEnabled = false;
        this.getData(this.queryParam);
        console.log('拖拽后保存成功');
      }
    }, () => {
    });
  }


  genID(length) {
    return Number(Math.random().toString().substr(3, length) + Date.now()).toString(36);
  }
  // 巡检
  handleInspectionClose(i) {
    this.inspectionList.splice(i, 1);
    this.inspectionListObj.splice(i, 1);
  }
  openInspectionDialog() {
    this.isInspectionVisible = true;
    this.inspectionDate = null;
    this.inspectionStartDate = null;
    this.inspectionEndDate = null;
  }
  taskRoutingInspectionChange() {
    this.inspectionList = [];
    this.inspectionListObj = [];
  }
  handleInspectionOk() {
    if (this.taskRoutingInspectionType === 1) {
      if (this.inspectionDate) {
        const val = this.inspectionDate ? this.datePipe.transform(this.inspectionDate, 'HH:mm:ss') : '';
        const startTime = val;
        const endTime = val;
        const obj = {
          startTime: startTime,
          endTime: endTime,
          intervalUnit: 'min',
          interval: this.interval
        };
        this.inspectionList = [...this.inspectionList, JSON.stringify(obj)];
        this.inspectionListObj = [...this.inspectionListObj, obj];
        this.isInspectionVisible = false;
      } else {
        this.message.create('warning', '必填项不能为空！');
      }
    } else {
      if (this.inspectionStartDate && this.inspectionEndDate) {
        if (this.inspectionStartDate < this.inspectionEndDate) {
          const startTime = this.inspectionStartDate ? this.datePipe.transform(this.inspectionStartDate, 'HH:mm:ss') : '';
          const endTime = this.inspectionEndDate ? this.datePipe.transform(this.inspectionEndDate, 'HH:mm:ss') : '';
          const obj = {
            startTime: startTime,
            endTime: endTime,
            intervalUnit: 'min',
            interval: this.interval
          };
          this.inspectionList = [...this.inspectionList, JSON.stringify(obj)];
          this.inspectionListObj = [...this.inspectionListObj, obj];
          this.isInspectionVisible = false;
        } else {
          this.message.create('warning', '结束时间不能小于开始时间！');
        }
      } else {
        this.message.create('warning', '必填项不能为空！');
      }
    }
  }
  handleInspectionCancel() {
    this.isInspectionVisible = false;
  }
  quickAddStatus(value, text, color) {
    const obj = {
      index: value,
      label: text,
      color: color
    };
    if (text === '强制完成') {
      obj['event'] = 'forceCompletion';
    }
    if (text === '延期') {
      obj['event'] = 'delay';
    }
    if (text === '强制完成') {
      obj['event'] = 'forceCompletion';
      obj['symbol'] = 'complete';
    }
    if (text === '已完成') {
      obj['symbol'] = 'complete';
    }
    this.statusOptionData = [obj, ...this.statusOptionData];
  }
  // 获取报表列表
  getReportData() {
    this.sys.getReportList().subscribe((res: any) => {
      this.reportList = res._embedded && res._embedded.vos ? res._embedded.vos : [];
    });
  }
  // 表格选择
  onCurrentPageDataChange($event): void {
    this.listOfCurrentPageData = $event;
    this.refreshCheckedStatus();
  }
  refreshCheckedStatus(): void {
    this.checked = this.listOfCurrentPageData.every(item => this.setOfCheckedId.has(item.id));
    this.indeterminate = this.listOfCurrentPageData.some(item => this.setOfCheckedId.has(item.id)) && !this.checked;
  }
  onAllChecked(checked: boolean): void {
    this.listOfCurrentPageData.forEach(item => this.updateCheckedSet(item.id, checked));
    this.refreshCheckedStatus();
  }
  updateCheckedSet(id: number, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(id);
    } else {
      this.setOfCheckedId.delete(id);
    }
  }
  onItemChecked(id: number, checked: boolean): void {
    this.updateCheckedSet(id, checked);
    this.refreshCheckedStatus();
  }
  // 关联稽核交互
  getAuditBoardsData() {
    const param = {
      page: 1,
      rows: 200
    };
    this.auditBoardListOption = [];
    this.sys.getAuditBoards(param).subscribe((res: any) => {
      if (res && res._embedded) {
        res._embedded.vos.forEach(item => {
          if (item.auditBoards) {
            item.auditBoards.forEach(_a => {
              this.auditBoardListOption.push(_a);
            });
          }
        });
      }
    });
  }
  getIndicatorBoardsData() {
    const param = {
      page: 1,
      rows: 200
    };
    this.indicatorBoardListOption = [];
    this.sys.getIndicatorBoards(param).subscribe((res: any) => {
      if (res && res._embedded) {
        res._embedded.vos.forEach(item => {
          if (item.indicatorBoards) {
            item.indicatorBoards.forEach(_a => {
              this.indicatorBoardListOption.push(_a);
            });
          }
        });
      }
    });
  }
  auditBoardChange(event) {
    if (event) {
      this.auditBoardItem = [];
      this.auditBoardList = null;
      const taskDataDate = localStorage.getItem('taskDataDate');
      const date = taskDataDate ? taskDataDate : this.datePipe.transform(new Date(), 'yyyy-MM-dd');
      this.sys.getAuditBoardsItem(event, date).subscribe((res: any) => {
        if (res && res._embedded) {
          this.auditBoardItemOption = res._embedded.vos;
        }
      });
    } else {
      this.auditBoardItemOption = [];
    }
  }
  indicatorBoardChange(event) {
    if (event) {
      this.indicatorBoardItem = [];
      this.indicatorBoardList = null;
      const taskDataDate = localStorage.getItem('taskDataDate');
      const date = taskDataDate ? taskDataDate : this.datePipe.transform(new Date(), 'yyyy-MM-dd');
      this.sys.getIndicatorBoardsItem(event, date).subscribe((res: any) => {
        if (res && res._embedded) {
          this.indicatorBoardItemOption = res._embedded.vos;
        }
      });
    } else {
      this.indicatorBoardItemOption = [];
    }
  }
  addAuditConfig() {
    this.isAddAuditVisible = true;
    this.auditBoardItem = [];
    this.getAuditBoardsData();
  }
  addMonitorConfig() {
    this.isAddMonitorVisible = true;
    this.indicatorBoardItem = [];
    this.getIndicatorBoardsData();
  }
  handleAddAuditOk() {
    this.isAddAuditVisible = false;
    if (this.addAuditTags.length) {
      this.addAuditTagsCache.forEach(i => {
        this.addAuditTags.forEach(j => {
          if (i.id !== j.id) {
            this.addAuditTags.push(i);
          }
        });
      });
    } else {
      this.addAuditTags = this.addAuditTagsCache;
    }
    if (this.addAuditTags.length) {
      const obj = {};
      this.addAuditTags = this.addAuditTags.reduce((cur, next) => {
        obj[next.id] ? '' : obj[next.id] = true && cur.push(next);
        return cur;
      }, []);
      const allItemIdList = [];
      this.addAuditTags.forEach(item => {
        allItemIdList.push(item.id);
      });
      if (this.formType === 'parent') {
        this.addForm.get('auditItemIdList').patchValue(allItemIdList);
      } else if (this.formType === 'child') {
        this.addChildForm.get('auditItemIdList').patchValue(allItemIdList);
      }
    }
  }
  handleAddAuditCancel() {
    this.isAddAuditVisible = false;
  }
  handleAddMonitorOk() {
    this.isAddMonitorVisible = false;
    if (this.addMonitorTags.length) {
      this.addMonitorTagsCache.forEach(i => {
        this.addMonitorTags.forEach(j => {
          if (i.id !== j.id) {
            this.addMonitorTags.push(i);
          }
        });
      });
    } else {
      this.addMonitorTags = this.addMonitorTagsCache;
    }
    if (this.addMonitorTags.length) {
      const obj = {};
      this.addMonitorTags = this.addMonitorTags.reduce((cur, next) => {
        obj[next.id] ? '' : obj[next.id] = true && cur.push(next);
        return cur;
      }, []);
      const allItemIdList = [];
      this.addMonitorTags.forEach(item => {
        allItemIdList.push(item.id);
      });
      if (this.formType === 'parent') {
        this.addForm.get('monitorItemIdList').patchValue(allItemIdList);
      } else if (this.formType === 'child') {
        this.addChildForm.get('monitorItemIdList').patchValue(allItemIdList);
      }
    }
  }
  handleAddMonitorCancel() {
    this.isAddMonitorVisible = false;
  }
  auditItemChange(event) {
    this.addAuditTagsCache = [];
    if (event && event.length) {
      this.auditBoardItemOption.forEach(item => {
        event.forEach(_e => {
          if (item.id === _e) {
            const obj = {
              id: item.id,
              name: item.name
            };
            this.addAuditTagsCache.push(obj);
          }
        });
      });
    }
  }
  indicatorItemChange(event) {
    this.addMonitorTagsCache = [];
    if (event && event.length) {
      this.indicatorBoardItemOption.forEach(item => {
        event.forEach(_e => {
          if (item.id === _e) {
            const obj = {
              id: item.id,
              name: item.name
            };
            this.addMonitorTagsCache.push(obj);
          }
        });
      });
    }
  }
  handleAuditTagsClose(i) {
    this.addAuditTags.splice(i, 1);
    if (this.addAuditTags.length) {
      const arr = [];
      this.addAuditTags.forEach(item => {
        arr.push(item.id);
      });
      if (this.formType === 'parent') {
        this.addForm.get('auditItemIdList').patchValue(arr);
      } else if (this.formType === 'child') {
        this.addChildForm.get('auditItemIdList').patchValue(arr);
      }
    } else {
      if (this.formType === 'parent') {
        this.addForm.get('auditItemIdList').patchValue([]);
      } else if (this.formType === 'child') {
        this.addChildForm.get('auditItemIdList').patchValue([]);
      }
    }
  }
  handleMonitorTagsClose(i) {
    this.addMonitorTags.splice(i, 1);
    if (this.addMonitorTags.length) {
      const arr = [];
      this.addMonitorTags.forEach(item => {
        arr.push(item.id);
      });
      if (this.formType === 'parent') {
        this.addForm.get('monitorItemIdList').patchValue(arr);
      } else if (this.formType === 'child') {
        this.addChildForm.get('monitorItemIdList').patchValue(arr);
      }
    } else {
      if (this.formType === 'parent') {
        this.addForm.get('monitorItemIdList').patchValue([]);
      } else if (this.formType === 'child') {
        this.addChildForm.get('monitorItemIdList').patchValue([]);
      }
    }
  }

  batchDeleteTask() {
    if (!this.setOfCheckedId || this.setOfCheckedId.size < 1) {
      this.message.info('请先选中需要删除的规则');
      return;
    }
    const ids = [];
    this.setOfCheckedId.forEach(value => {
      ids.push(value);
    });
    this.modalService.confirm({
      nzContent: '确认批量删除' + this.setOfCheckedId.size + '条任务吗？',
      nzTitle: '批量删除任务',
      nzCancelText: '取消',
      nzOnOk: () => {
        this.sys.batchDeleteTaskDef(ids).subscribe(() => {
          this.setOfCheckedId.clear();
          this.queryChange({});
          return true;
        });
      }
    });
  }

  batchEdit() {
    console.log(this.setOfCheckedId.values());
    if (this.setOfCheckedId && this.setOfCheckedId.size > 0) {
      this.showBatchEdit = true;
    } else {
      this.message.info('请先选中需要修改的规则');
    }
    this.batchEditWidget = [
      {key: 'groupId', title: '面板分组'},
      {key: 'operationOrgCode', title: '组织/班次/岗位'},
      {key: 'isAuth', title: '是否需要授权'},
      {key: 'createWayType', title: '创建方式'},
      {key: 'preTaskId', title: '前置任务'},
      {key: 'automation', title: '频率设置'},
      {key: 'description', title: '任务描述'}
    ];


    // if (this.taskSystemParameter && this.taskSystemParameter.audit && this.taskSystemParameter.audit === 'report'){
    //   this.batchEditWidget.push({key: 'auditItemIdList', title: '关联报表配置'});
    // }
    //
    // if (this.taskSystemParameter && this.taskSystemParameter.audit && this.taskSystemParameter.audit === 'audit') {
    //   this.batchEditWidget.push({key: 'auditItemIdList', title: '关联稽核指标'});
    // }
    // if (this.taskSystemParameter && this.taskSystemParameter.indicator && this.taskSystemParameter.indicator === 'indicator') {
    //   this.batchEditWidget.push({key: 'monitorItemIdList', title: '关联监控指标'});
    // }

  }
  editWidget(code: string, title: string) {
    console.log(code);
    if (!code) {
      this.message.info('请先选择批量编辑的字段');
      return;
    }
    this.showEditWidget = true;
    this.widgetCode = code;
    this.widgetTitle = title;
    for (const i in this.batchEditForm.controls) {
      this.batchEditForm.get(i).clearValidators();
    }
    if (code !== 'taskHandleConfig') {
      this.batchEditForm.get(code).setValidators([Validators.required]);
    }
    this.batchEditForm.reset();
    this.taskConfigForm.reset();
    this.taskConfigData = [];
    const ids = [];
    this.setOfCheckedId.forEach(value => {
      ids.push(value);
    });
    this.batchEditForm.get('ids').setValue(ids);
  }

  submitBatchEdit(): void {
    if (this.widgetCode && this.widgetCode === 'automation') {
      this.setScheduler.schedulerOnSubmit();
      const schedulerData = JSON.parse(this.batchEditForm.get('automation').value);
      let  schedulerValid = true;
      if (schedulerData.type === 'weekly' || schedulerData.type === 'monthly' || schedulerData.type === 'months') {
        if (!schedulerData.days || !schedulerData.days.length) {
          schedulerValid = false;
        }
      }
    }
    console.log(this.batchEditForm.value);
    // tslint:disable-next-line:forin
    for (const i in this.batchEditForm.controls) {
      this.batchEditForm.controls[i].markAsDirty();
      this.batchEditForm.controls[i].updateValueAndValidity();
    }
    if (this.batchEditForm.invalid ) {
      return;
    }
    this.batchEditForm.get('boardId').setValue(this.boardId);
    const params = this.batchEditForm.value;
    this.submitLoading = true;
    if (params['preTaskId'] && params['preTaskId'].length) {
      params['preTaskId'] = params['preTaskId'].join(',');
    }
    this.sys.batchEditTask(params).subscribe(res => {
      this.submitLoading = false;
      this.showEditWidget = false;
      this.queryChange({});
      console.log(res);
    }, error => {
      this.showEditWidget = false;
    });
  }

  batchChangeDepartment(event) {
    if (event) {
      this.getWorks({operationOrgCode: event});
      this.getJob({orgCode: event});
    } else {
      this.workDefsOption = [];
      this.jobOptions = [];
    }
    // this.addForm.get('operationRoleCode').patchValue('');
    this.batchEditForm.get('operationRoleCodes').patchValue([]);
    this.batchEditForm.get('workDefId').patchValue('');
  }

  getBatchEditSchedulerData(event) {
    this.batchEditForm.get('automation').patchValue(JSON.stringify(event.config));
    this.batchEditForm.get('automationDesc').patchValue(event.text);
  }

  search() {
    const queryParam = this.queryForm.value;
    queryParam['page'] = 1;
    queryParam['rows'] = 200;
    console.log(queryParam);
    this.getData(queryParam);
  }

  reset() {
    this.queryForm.get('nameFuzzy').setValue('');
    this.queryForm.get('automationDescFuzzy').setValue('');
    this.queryForm.get('operationOrgCodeList').setValue([]);
    this.queryForm.get('workDefIdList').setValue([]);
    this.queryForm.get('operationRoleCodeFuzzy').setValue('');
    this.queryForm.get('relevanceList').setValue([]);
  }
  taskDatestartChange(event, type) {
    if (type === 'parent') {
      const periodEndAt = this.addForm.get('periodEndAt').value;
      if (periodEndAt && event) {
        if (this.datePipe.transform(event, 'yyyy-MM-dd') > this.datePipe.transform(periodEndAt, 'yyyy-MM-dd')) {
          this.message.error('开始时间不能晚于开始时间！');
          this.addForm.get('periodStartAt').patchValue(null);
        }
      }
    } else if (type === 'child') {
      const periodEndAt = this.addChildForm.get('periodEndAt').value;
      if (periodEndAt && event) {
        if (this.datePipe.transform(event, 'yyyy-MM-dd') > this.datePipe.transform(periodEndAt, 'yyyy-MM-dd')) {
          this.message.error('开始时间不能晚于开始时间！');
          this.addChildForm.get('periodStartAt').patchValue(null);
        }
      }
    }
  }
  taskDateEndChange(event, type) {
    if (type === 'parent') {
      const periodStartAt = this.addForm.get('periodStartAt').value;
      if (periodStartAt && event) {
        if (this.datePipe.transform(event, 'yyyy-MM-dd') < this.datePipe.transform(periodStartAt, 'yyyy-MM-dd')) {
          this.message.error('结束时间不能早于开始时间！');
          this.addForm.get('periodEndAt').patchValue(null);
        }
      }
    } else if (type === 'child') {
      const periodStartAt = this.addChildForm.get('periodStartAt').value;
      if (periodStartAt && event) {
        if (this.datePipe.transform(event, 'yyyy-MM-dd') < this.datePipe.transform(periodStartAt, 'yyyy-MM-dd')) {
          this.message.error('结束时间不能早于开始时间！');
          this.addChildForm.get('periodEndAt').patchValue(null);
        }
      }
    }
  }
}
